import type { ICustomFieldDefinition } from '@awork/features/project/models/custom-field-definition.model'
import { CustomFieldDefinition } from '@awork/features/project/models/custom-field-definition.model'

interface ICustomFieldDefinitionLink extends ICustomFieldDefinition {
  order: number
  projectId?: string
  projectTemplateId?: string
  workflowId?: string
}

export type CustomFieldDefinitionLinkEntity = 'projects' | 'projectTemplates' | 'workflows'

/**
 * Represents the custom field associated to a Project, Project Template, or Workflow.
 * It includes the order in which it should be displayed.
 */
export class CustomFieldDefinitionLink extends CustomFieldDefinition implements ICustomFieldDefinitionLink {
  order: number
  projectId?: string
  projectTemplateId?: string
  workflowId?: string

  constructor(customFieldDefinition: ICustomFieldDefinitionLink) {
    super(customFieldDefinition)

    Object.assign(this, customFieldDefinition)
  }
}
